var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "contents-inner" }, [
      _c("div", { staticClass: "feature-block" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "environment",
            style:
              "background: url(" +
              _vm.userOfferImageUrlForSp +
              "/environment_bg.png) no-repeat top;",
          },
          [
            _c(
              "ul",
              _vm._l(
                _vm.requirements.features.environments,
                function (environment) {
                  return _c("li", {
                    key: "environment-star-" + environment.id,
                    class: "enviro-star-0" + environment.name,
                    style:
                      "background: url(" +
                      _vm.userOfferImageUrlForSp +
                      "/feature_star_img.png) no-repeat;",
                    attrs: {
                      "data-test": "environment-star-" + environment.id,
                    },
                  })
                }
              ),
              0
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contents-inner" }, [
      _c("div", { staticClass: "feature-block" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "work-feature",
            style:
              "background: url(" +
              _vm.userOfferImageUrlForSp +
              "/work_feature_bg.png) no-repeat top;",
          },
          [
            _c(
              "ul",
              _vm._l(_vm.requirements.features.work, function (work) {
                return _c(
                  "li",
                  {
                    key: "work-feature-bar-" + work.id,
                    staticClass: "logout",
                    attrs: { "data-test": "work-feature-bar-" + work.id },
                  },
                  [_c("span", { class: "work-feature-bar-0" + work.name })]
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n2" }, [
      _c("span", [_vm._v("働く環境の特徴")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n2" }, [
      _c("span", [_vm._v("この仕事の特徴")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }